<template>
  <span ref="checkboxspan">
    <input
      v-if="schema.attributes.editing && !disabledForAdminOnly"
      v-model="value"
      ref="checkbox"
      type="checkbox"
      :aria-label="prettyValue"
      :autocomplete="schema.autocomplete"
      :class="schema.fieldClasses"
      :disabled="disabled || null"
      :id="getFieldID(schema)"
      :nameId="schema.inputName" />
    <template v-else>
      <span v-if="!lodash.isNull(value)" class="response">
        {{ prettyValue }}
      </span>
      <span
        v-else-if="!schema.attributes.editing"
        style="font-style: italic; color: #555">
        Not available
      </span>
    </template>
    <div
      class="form-input-hint text-error"
      v-if="schema.attributes.editing && disabledForAdminOnly">
      Field is restricted to site administrators.
    </div>
  </span>
</template>

<script>
import { MixinDataToReactiveData } from 'assets/js/util';

// This is a lightly modified version of vue-form-generator's checkbox field.
import { abstractField } from 'components/Widgets/FormGenerator';
import FieldCommon from './FieldCommon';

export default {
  name: 'field-q-switch',

  computed: {
    // prettyValue replaces true/false with yes/no.
    prettyValue() {
      return this.value ? 'Yes' : 'No';
    },
  },

  mixins: [abstractField, FieldCommon],

  setup() {
    const afd = MixinDataToReactiveData(abstractField);
    const fcd = MixinDataToReactiveData(FieldCommon);
    return {
      ...afd,
      ...fcd,
    };
  },

  data() {
    return {
      formIcon: null,
      label: null,
    };
  },

  beforeUnmount() {
    if (!this.schema.attributes.editing || this.disabledForAdminOnly) return;

    // Undo all of the DOM manipulation below.
    if (this.formIcon) {
      this.formIcon.remove();
    }
    if (this.label) {
      this.label.classList.remove('form-switch');
    }
    // Move the checkbox back in here.
    this.$refs.checkboxspan.appendChild(this.$refs.checkbox);
  },

  mounted() {
    if (!this.schema.attributes.editing || this.disabledForAdminOnly) return;

    // Adjust the DOM to what spectre expects.
    const checkboxId = this.getFieldID(this.schema);
    const checkbox = document.getElementById(checkboxId);
    const fieldWrap = this.$refs.checkboxspan.parentNode;
    const formGroup = fieldWrap.parentNode;
    const label = formGroup.getElementsByTagName('label')[0];
    label.classList.add('form-switch');
    this.label = label;

    const formIcon = document.createElement('i');
    formIcon.className = 'form-icon';
    label.appendChild(this.$refs.checkbox);
    label.appendChild(formIcon);
    this.formIcon = formIcon;
  },
};
</script>

<style lang="scss" scoped>
input {
  margin-left: 12px;
}
</style>
